/* ---------------------------------------------------------------------------
 * youtube-consent.js — DISABLED
 * ---------------------------------------------------------------------------
 * The GDPR consent gate is not used on the Australian store. Videos embed
 * directly via snippets/youtube-consent-embed.liquid, which loads YouTube
 * through youtube-nocookie.com.
 *
 * The original script scanned the page for YouTube embeds and replaced them
 * with a "Video laden" placeholder. It has been turned off rather than
 * deleted, so the file it is linked from does not 404 and so it can be
 * restored later if this theme is ever shared with the German store.
 *
 * A no-op stub is left on window in case anything else calls into it.
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  var noop = function () {};

  window.YouTubeConsent = window.YouTubeConsent || {
    disabled: true,
    init: noop,
    refresh: noop,
    loadVideo: noop,
    loadAll: noop,
    hasConsent: function () { return true; },
    grantConsent: noop,
    revokeConsent: noop
  };
})();